module.exports = __webpack_public_path__ + "static/media/watch.af9990ea.jpeg";